import { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';
import { storeToRefs } from 'pinia';
import { useLoaderAtStartStore } from '@/shared/components/loaders/LoaderAtStartApp/store';

export const storiesRoute: RouteRecordRaw = {
  path: `/onboarding`,
  name: AppScreens.Onboarding,
  component: () => import('@/modules/onboarding/views/Onboarding.vue'),
  meta: {
    layout: 'empty',
  },
  beforeEnter() {
    const { visible, loaderIsRequired } = storeToRefs(useLoaderAtStartStore());

    visible.value = false;
    loaderIsRequired.value = false;
  },
};
